<template>
<span v-if="$page.props.flash.message" class="absolute ml-2 my-1 text-sm text-green-700">{{ $page.props.flash.message }}</span>

<ul class="text-white rooom-list mt-6 rooom-scrollbar">
    <li class="px-3 py-2 cursor-pointer flex justify-between"
    :class="{ active: station.id == station_id }"
    v-for="station in stations" :key="station.id">
        <Link class="w-full" :href="route('station.edit', station.id)">{{ stationTitle(station) }}</Link>
        <button v-if="!delete_station_form.processing" @click="() =>deleteStation(station.id)">
            <i class="trash"></i></button>
        <span v-if="delete_station_form.processing &&
        delete_station_form.station_id == station.id"><Spinner/></span>
    </li>
</ul>
<div class="my-4 text-center">
    <Link :href="route('station.create', tour_identifier)" class="btn btn-gradient btn-sm btn-w-icon">
        <i class="add"></i>Add station
    </Link>
</div>

</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Spinner from '@/UI/Spinner';

export default {
    components: {
        Link,
        Spinner
    },
    props:{
        changeLanguage: Function,
        station_id: Number,
    },
    data() {
        return {
            tour_identifier: this.$page.props.tour.data.identifier,
            stations: this.$page.props.tour.data.stations,
            fallback_lang: this.$page.props.tour.data.fallback_language,
            delete_station_form: this.$inertia.form({
                _method: 'POST',
                station_id: null,
            }),
        }
    },
    methods: {
        stationTitle(station){
            return station.title.localized_text[this.fallback_lang];
        },
        deleteStation(station_id){
          this.delete_station_form.station_id = station_id;
          this.delete_station_form.delete(route('station.delete', station_id), {
            preserveScroll: true,
            onSuccess: () => {
                this.stations = this.$page.props.tour.data.stations
                this.changeLanguage(this.$page.props.tour.data.fallback_language)
                }
            })
        }
    }
}
</script>
